import React, { useState, useEffect } from 'react';
import api from '../services/api';

function errorMessage(err) {
  if (err.status === 404) return 'Không tìm thấy bài làm';
  if (err.status === 403) return 'Bạn không có quyền xem bài làm này';
  return err.message || 'Đã có lỗi xảy ra';
}

function groupAnswersByStep(answers) {
  const stepMap = new Map();

  answers.forEach((answer) => {
    const step = answer.step_number;
    if (!stepMap.has(step)) stepMap.set(step, []);
    stepMap.get(step).push(answer);
  });

  return Array.from(stepMap.entries())
    .sort((a, b) => (a[0] ?? 0) - (b[0] ?? 0))
    .map(([step, stepAnswers]) => ({ step, answers: stepAnswers }));
}

function IbsFormSubmissionDetail({ submissionId }) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    api.getIbsFormSubmission(submissionId)
      .then((data) => {
        if (active) setDetail(data);
      })
      .catch((err) => {
        if (active) setError(errorMessage(err));
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [submissionId]);

  if (loading) return <p>Loading...</p>;
  if (error) return <div className="error-message">{error}</div>;
  if (!detail) return null;

  const steps = groupAnswersByStep(detail.answers || []);

  return (
    <div className="submission-detail">
      <div className="submission-detail-meta">
        <p><strong>Người làm:</strong> {detail.user_full_name || detail.username}</p>
        <p><strong>Bảng khảo sát:</strong> {detail.form_name} ({detail.form_code})</p>
        <p><strong>Hoàn thành:</strong> {detail.is_complete ? 'Có' : 'Chưa'}</p>
        <p><strong>Nộp lúc:</strong> {detail.submitted_at ? new Date(detail.submitted_at).toLocaleString() : '-'}</p>
        <p><strong>Số câu đã trả lời:</strong> {detail.answer_count}</p>
      </div>

      {steps.length === 0 ? (
        <p>Chưa có câu trả lời nào.</p>
      ) : (
        <div className="step-list">
          {steps.map(({ step, answers }) => (
            <div key={step ?? 'none'} className="step-group">
              <h3>Bước {step ?? '-'}</h3>
              <ol className="question-list">
                {answers.map((answer) => (
                  <li key={answer.id} className="question-item">
                    <div className="question-text">{answer.question_text}</div>
                    <div className="answer-value">Mức độ: {answer.scale_value}</div>
                  </li>
                ))}
              </ol>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default IbsFormSubmissionDetail;
